import React, { useEffect, useState } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import Button from "./Button";
import ProgressBar from "./ProgressBar";
import AddressForm from "./AddressForm";
// import RoomsForm from "./RoomsForm";
import PropertyTypeForm from "./PropertyTypeForm";
import { apiCreateProperty } from "../services/apiService";

const AddProperty = () => {
  const {
    user,
    modal,
    setModal,
    address,
    setAddress,
    usersProperties,
    setUsersProperties,
    activateError,
  } = useStateContext();

  const [isLoading, setIsloading] = useState(false);
  const [page, setPage] = useState(1);
  const pages = 2; //set the number of questions

  useEffect(() => {
    setAddress({
      landlordId: user.id,
      street: "",
      street2: "",
      city: "",
      state: "--",
      zipCode: "",
      homeType: "",
      coordinates: "",
    });
    // eslint-disable-next-line
  }, []);

  const handleBack = () => {
    setPage(page - 1);
  };

  const handleNext = () => {
    if (hasError()) {
      return;
    } else {
      setPage(page + 1);
    }
  };

  const handleSubmit = async () => {
    setIsloading(true);
    if (hasError()) {
      setIsloading(false);
      return;
    } else {
      const response = await apiCreateProperty(address);
      if (response.hasError) {
        console.log(response.error.response.statusText);
        //TODO: setError to read statusText
        setIsloading(false);
        return;
      } else {
        setUsersProperties((prevState) => [...prevState, response.data]);
        setModal(!modal.addProperty);
        setIsloading(false); // do we need this if closing the modal?
      }
    }
  };

  const hasError = () => {
    if (page === 1 && address.homeType === "") {
      activateError("homeType");
      return true;
    } else if (page === 2 && address.street === "") {
      activateError("street");
      return true;
    } else if (page === 2 && address.city === "") {
      activateError("city");
      return true;
    } else if (page === 2 && address.state === "--") {
      activateError("state");
      return true;
    } else if (
      page === 2 &&
      (address.zipCode === "" || address.zipCode.length < 5)
    ) {
      activateError("zipCode");
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      className="w-screen h-screen fixed top-0 left-0 right-0 bottom-0 bg-white mt-20 
    overflow-y-auto overscroll-none z-10"
    >
      <div className="grid justify-items-center">
        <ProgressBar pages={pages} currentPage={page} />
        {page === 1 && <PropertyTypeForm />}
        {page === 2 && (
          <>
            <AddressForm />
            <div className="px-10">
              <div
                className="max-w-[500px] text-center bg-gray-100 border-gray-400 
                border-2 rounded-2xl mt-10 p-5"
              >
                Your address is kept private until you decide to share it.
              </div>
            </div>
          </>
        )}
        <div
          className={`flex justify-center w-full mb-40 ${
            page === 1 ? "inline-block mt-10 " : "mt-[104px]"
          }`}
        >
          <Button
            background="bg-slate-400"
            text="text-white"
            opacity="bg-opacity-100"
            title={page === 1 ? "Cancel" : "Back"}
            height="h-10"
            width="w-24"
            borderColor="border-none"
            borderHover="hover:border-snappily-orange"
            customFunc={
              page === 1
                ? () => {
                    setModal(!modal.addProperty);
                  }
                : handleBack
            }
          />
          <Button
            isDisabled={isLoading}
            background="bg-snappily-orange"
            text="text-white"
            opacity="bg-opacity-100"
            title={page === pages ? "Submit" : "Next"}
            height="h-10"
            width="w-24"
            borderColor="border-none"
            borderHover="hover:border-snappily-orange"
            customFunc={page === pages ? handleSubmit : handleNext}
          />
        </div>
      </div>
    </div>
  );
};

export default AddProperty;
